import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import { createElement } from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const ItemModals = (props) => {
  const handleItem = async (event, type) => {
    event.preventDefault();
    const page = {
      elementType: type,
      referenceName: "UnNamed " + type,
      items: [],
    };
    /* eslint-disable no-unused-vars */
    const result = await createElement(page).then(
      (result) => {
        toastr.success("Successfully Created New Page", "Success");
        let push_url = "/item/" + type + "/" + result.data._id;
        if (type === "tabItem") {
          push_url = "/tab/" + result.data._id;
        }
        if (type === "textGrid") {
          push_url = "/textgrid/" + result.data._id;
        }

        if (type === "highlightTextGrid") {
          push_url = "/highlightTextGrid/" + result.data._id;
        }

        if (type === "epg") {
          push_url = "/epg/" + result.data._id;
        }

        if (type === "embed") {
          push_url = "/embed/" + result.data._id;
        }

        if (type === "gallery") {
          push_url = "/item/gallery/" + result.data._id;
        }

        props.history.push(push_url);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
      }
    );
    /* eslint-disable no-unused-vars */
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">Item List</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col sm="4">
            <a
              href="#!"
              onClick={(event) => handleItem(event, "portraitSlider")}
            >
              Portrait Slider
            </a>
          </Col>
          <Col sm="4">
            <a
              href="#!"
              onClick={(event) => handleItem(event, "landscapeSlider")}
            >
              Landscape Slider
            </a>
          </Col>
          <Col sm="4">
            <a
              href="#!"
              onClick={(event) => handleItem(event, "movieCarousel")}
            >
              Movie Carousel
            </a>
          </Col>
        </Row>
        <Row>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "newsCarousel")}>
              News Carousel
            </a>
          </Col>
          <Col sm="4">
            <a
              href="#!"
              onClick={(event) => handleItem(event, "articleSlider")}
            >
              Article Slider
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "newsSlider")}>
              News Slider
            </a>
          </Col>
        </Row>
        <Row>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "tabItem")}>
              Tab Item
            </a>
          </Col>
          <Col sm="4">
            <a
              href="/#!"
              onClick={(event) => handleItem(event, "portraitList")}
            >
              Portrait List
            </a>
          </Col>
          <Col sm="4">
            <a
              href="#!"
              onClick={(event) => handleItem(event, "landscapeList")}
            >
              Landscape List
            </a>
          </Col>
        </Row>
        <Row>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "3dCarousel")}>
              3D Carousel
            </a>
          </Col>
          <Col sm="4">
            <a
              href="#!"
              onClick={(event) => handleItem(event, "multiCarousel")}
            >
              Multi Carousel
            </a>
          </Col>
          <Col sm="4">
            <a
              href="#!"
              onClick={(event) => handleItem(event, "bigportraitSlider")}
            >
              Big Portrait Slider
            </a>
          </Col>
        </Row>
        <Row>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "articleList")}>
              Article List
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "newsList")}>
              News List
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "adBanner")}>
              Ad Banner
            </a>
          </Col>
        </Row>

        <Row>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "textGrid")}>
              Text Grid Element
            </a>
          </Col>
          <Col sm="4">
            <a
              href="#!"
              onClick={(event) => handleItem(event, "highlightTextGrid")}
            >
              Highlight Text Grid
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "grid")}>
              Grid Element
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "doubleGrid")}>
              Double Grid Element
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "epg")}>
              EPG
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "embed")}>
              Embed
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handleItem(event, "gallery")}>
              Gallery
            </a>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};
export default ItemModals;
